/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { Form, FormButton, FormInput, Margin, Text } from 'shared/components'
import { auth } from 'routes/route.map'
import config from 'config'

import ResetPasswordModal from './components/resetPasswordModal'
import * as styles from './styles'

const MobileLoginFormComponent = ({ form, onSubmitForm }) => {
  const history = useHistory()
  const [showResetModal, setShowResetModal] = useState(false)
  const browserWindow = globalThis.window

  const handleBackClick = () => {
    // Navigate back - you can customize this based on your app flow
    history.goBack()
  }

  const handleResetPasswordClick = () => {
    setShowResetModal(true)
  }

  const handleModalCancel = () => {
    setShowResetModal(false)
  }

  const handleModalConfirm = () => {
    setShowResetModal(false)
    // Navigate to reset password page
    history.push(auth.resetPassword())
  }

  const onGoogleLogin = () => {
    const redirect = encodeURIComponent(browserWindow?.location?.href ?? '')

    if (!browserWindow) {
      return
    }

    browserWindow.location.href = `${config.api.url}/oauth2/authorization/google?redirect=${redirect}`
  }

  return (
    <div css={styles.mobileContainer}>
      {/* Header with back arrow and title */}
      <div css={styles.header}>
        <FontAwesomeIcon
          icon="arrow-left"
          css={styles.backArrow}
          onClick={handleBackClick}
        />
        <div css={styles.headerContent}>
          <Text as="h1" css={styles.title}>
            Log in
          </Text>
        </div>
      </div>

      {/* Form Content */}
      <div css={styles.formContainer}>
        <Form form={form} onSubmit={onSubmitForm} css={styles.form}>
          {/* Email Field */}
          <Margin bottom={3}>
            <FormInput
              name="email"
              type="email"
              placeholder="Email"
              css={styles.inputField}
            />
          </Margin>

          {/* Password Field */}
          <Margin bottom={4}>
            <FormInput
              autoComplete="new-password"
              name="password"
              type="password"
              placeholder="Password"
              css={styles.inputField}
            />
          </Margin>

          {/* Reset Password Link */}
          <div css={styles.resetPasswordContainer}>
            <Text
              css={styles.resetPasswordText}
              onClick={handleResetPasswordClick}
            >
              Reset Password
            </Text>
          </div>

          <Margin tb={2}>
            <div css={styles.separator}>
              <span css={styles.separatorText}>OR</span>
            </div>
          </Margin>

          <div css={styles.googleButtonContainer}>
            <FormButton
              type="button"
              css={styles.googleButton}
              onClick={onGoogleLogin}
            >
              <FontAwesomeIcon
                icon={['fab', 'google']}
                css={styles.googleIcon}
              />
              <Text css={styles.googleButtonText}>Continue with Google</Text>
            </FormButton>
          </div>

          {/* Spacer to push button to bottom */}
          <div css={styles.spacer} />

          {/* Continue Button */}
          <div css={styles.buttonContainer}>
            <FormButton submit css={styles.continueButton}>
              <Text css={styles.buttonText}>Continue</Text>
            </FormButton>
          </div>
        </Form>
      </div>

      {/* Home indicator (for iOS style) */}
      <div css={styles.homeIndicator} />

      {/* Reset Password Modal */}
      <ResetPasswordModal
        isVisible={showResetModal}
        onCancel={handleModalCancel}
        onConfirm={handleModalConfirm}
      />
    </div>
  )
}

MobileLoginFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
}

export default observer(MobileLoginFormComponent)
